import React, { useState } from "react";
import { Box, Typography, Modal, Fade } from "@mui/material";

interface ChatImageProps {
  url: string;
  caption?: string;
  size?: 'regular' | 'compact';
}

export const ChatImage: React.FC<ChatImageProps> = ({ url, caption, size = 'regular' }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const dims = size === 'compact'
    ? { maxW: 120, maxH: 120 }
    : { maxW: 200, maxH: 200 };

  return (
    <>
      <Box
        display="flex"
        gap={1}
        alignItems="baseline"
        justifyContent="center"
        flexDirection="column"
      >
        <Box
          component="img"
          src={url}
          alt="Image"
          sx={{
            maxWidth: dims.maxW,
            maxHeight: dims.maxH,
            objectFit: "contain",
            cursor: "pointer"
          }}
          onClick={handleOpenModal}
        />
        {caption && size !== 'compact' && <Typography variant="body2">{caption}</Typography>}
      </Box>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        sx={{
          overflow: 'auto',
          display: 'flex',
          justifyContent: 'center',
          p: 4,
        }}
      >
        <Fade in={openModal}>
          <Box
            sx={{
              bgcolor: 'background.paper',
              boxShadow: 24,
              borderRadius: 1,
              p: 2,
              minHeight: 'fit-content', 
            }}
          >
            <Box
              component="img"
              src={url}
              alt="Image"
              sx={{
                display: 'block',
                height: 'auto',
                width: 'auto',
              }}
            />
          </Box>
        </Fade>
      </Modal>
    </>
  );
}; 
